import { PayloadAction } from "@reduxjs/toolkit";

/**
 * This function bypasses the type checker to update the value of an element. Use at your own risk.
 * @param state the redux state
 * @param action your payload action
 */

export const updateElementValue = (
  state: any,
  action: PayloadAction<{ elementName: any; value: any }>
) => {
  // @ts-ignore - This method doesn't have typesupport
  state[action.payload.elementName] = action.payload.value;
};
